export function alertYesNo(obj) {
  let hasTitle = obj.title;
  let hasBody = obj.body;
  let onYes = obj.onYes;
  let onNo = obj.onNo;

  let backdrop = document.createElement("div");
  backdrop.className = "window-background";
  backdrop.setAttribute("data-role", "backdrop");
  backdrop.addEventListener("click", (event) => {
    if (event.target.getAttribute("data-role") === "backdrop") {
      document.body.dispatchEvent(onNo);
      cancelAlert();
    }
  }, { once: true });

  let modal = document.createElement("div");
  modal.setAttribute("data-role", "modal");
  modal.className = "window"

  let header
  if (hasTitle) {
    header = document.createElement("div")
    header.className = "window-header"
    header.innerHTML = "<h3>" + obj.title + "</h3>";
    modal.append(header);
  }

  let body = document.createElement("div");
  if (hasBody) body.innerHTML = `<div class="dupo-menu-pane mb-2"><div class="dupo-menu-pane-row">${obj.body}</div></div>`;
  else body.innerHTML = `<div class="dupo-menu-pane mb-2"><div class="dupo-menu-pane-row"></div></div>`;
  body.className = "window-body";
  modal.append(body);


  let footerWrap = document.createElement("div");
  footerWrap.className = "window-body";
  let footerWrap2 = document.createElement("div");
  footerWrap2.className = "dupo-menu-pane";
  let footer = document.createElement("div");
  footer.className = "dupo-menu-pane-button-row";
  let yes = document.createElement("button")
  yes.setAttribute("type", "button");
  yes.innerHTML = `<i class="bi bi-trash-fill me-1"></i> Delete`;
  yes.addEventListener("click", (event) => {
    document.body.dispatchEvent(onYes);
    cancelAlert();
  }, { once: true });

  let no = document.createElement("button")
  no.setAttribute("type", "button");
  no.innerHTML = `<i class="bi bi-x-lg me-1"></i> Cancel`;
  no.addEventListener("click", (event) => {
    document.body.dispatchEvent(onNo);
    cancelAlert();
  }, { once: true });

  footer.append(yes);
  footer.append(no);
  footerWrap2.append(footer);
  footerWrap.append(footerWrap2);
  modal.append(footerWrap);

  backdrop.append(modal);

  document.getElementById("dupo-app").append(backdrop);

  function cancelAlert() {
    backdrop.remove();
    if (hasTitle) header.remove();
    body.remove();
    yes.remove();
    no.remove();
    footer.remove();
    modal.remove();
  }
}